import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';

const host = publicConfig.external_address;

export const Invoices = {
  fetchInvoices: (ssoId, token, callback) => {
    const requestParams = {
      host: host,
      path: `/v1/journal/fees-journal/invoices/user/${ssoId}?year=all`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    });
  },

  fetchInvoicesByYear: (ssoId, token, year, limit, skip, callback) => {
    const requestParams = {
      host: host,
      path: `/v1/journal/fees-journal/invoices/user/${ssoId}?year=${year}&limit=${limit}&skip=${skip}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    });
  },

  fetchInvoicesYears: (ssoId, token, callback) => {
    const requestParams = {
      host: host,
      path: `/v1/journal/fees-journal/invoices/years/user/${ssoId}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    });
  },

  fetchInvoiceEntries: (token, invoiceId, callback) => {
    const requestParams = {
      host: host,
      path: `/v1/journal/fees-journal/invoices/entries/invoice/${invoiceId}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    });
  },

  fetchInvoiceEntriesByType: (token, invoiceId, txnType, callback) => {
    const requestParams = {
      host: host,
      path: `/v1/journal/fees-journal/invoices/entries/invoice/${invoiceId}/type/${txnType}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    });
  }
};
